/** Doctor surface shell (D-01..D-04). Responsive: sidebar on desktop, bottom nav on mobile. */

import { ListIcon, PlusIcon, RoleLayout, UserIcon } from "../../components/RoleLayout";
import type { RoleNavItem } from "../../components/RoleLayout";
import { DOCTOR_RX_CREATION_ENABLED } from "../../lib/features";

const NAV: RoleNavItem[] = [
  { to: "/staff/doctor/prescriptions", label: "Prescriptions", short: "Rx", icon: <ListIcon /> },
  ...(DOCTOR_RX_CREATION_ENABLED
    ? [{ to: "/staff/doctor/create", label: "Write Rx", short: "Write", icon: <PlusIcon /> }]
    : []),
  { to: "/staff/doctor/profile", label: "Profile", short: "Profile", icon: <UserIcon /> },
];

export function DoctorLayout() {
  return <RoleLayout title="Doctor" nav={NAV} />;
}
